export enum ConnectionStatus {
  OK = 'ok',
  CONNECTED = 'connected',
  NOT_CONNECTED = 'not-connected',
  ERROR = 'error',
  AWAITING_CONNECTION = 'awaiting-connection',
  CONNECTING = 'connecting',
}
